<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
*{
  margin:0;
  padding:0;
  list-style:none;
  text-decoration:none;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 14px;
}
 /* 登录 */
.img-code{width: 30%;height: 36px;float: right;margin:0 10%;border: none;cursor: pointer;}
.get-code{color:#f56c6c;}
.code{width: 50% !important;float: left;}

.title{
  margin-bottom: 20px;
  color: #428bca;
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 8px 15px;
}
.addBtn{
  float: right;
  margin-bottom: 10px;
}
/* 字体颜色 */
.text-red{
  color: #d9534f;
}
.text-blue{
  color: #428bca;
}
.colorBBB{
  color: #bbb;
}
.pointer{
  cursor: pointer;
}
.mtop20{
  margin-top: 20px;
}
.marginTop30{
  margin-top: 30px;
}
.paddingTB7{padding-top:7px;padding-bottom: 7px;margin-right: 20%}
/* 弹窗 */
.shade-box{
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 1000;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4); 
}
.shade-content{
  position: relative;
  z-index: 1000;
  width: 500px;
  top: 12%;
  margin: 10px auto;
  background: rgb(255, 255, 255);
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
  color: black;
  border-radius:5px;
}
.dialog-title-bg{
  background-color:#eee;
  padding: 16px;
  color: #2a6496;
}
.position-top{top:33%}
.shade-width{width:700px}
.width7{
  width: 82%;margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue